import { Fragment } from "react";
import { confirmCustomHeader, deleteCustomHeader } from "src/pages/OfferPage/CustomSections/CustomSectionsUtils";
import { useConfirmSectionMutation, useDeleteSectionMutation, useEditSectionMutation } from "src/api/v1/section-ApiSlice";
import { getFrontendURL } from "src/utils/url";

export const SectionTools = (
    {
        projectId,
        table,
        setCustomSectionButtonPressed,
        modifySection,
        setModifySection,
        setConfirmedHeader,
        customSection,
        confirmedHeader,
        setNewTable,
        setCurrentRowInEditing,
    } : {
        projectId: number;
        table: any;
        setCustomSectionButtonPressed: any;
        modifySection: any;
        setModifySection: any;
        setConfirmedHeader: any;
        customSection: any;
        confirmedHeader: any;
        setNewTable: any;
        setCurrentRowInEditing: any;
    }
) => {

    const [ deleteSection ] = useDeleteSectionMutation();
    const [ confirmSection ] = useConfirmSectionMutation();
    const [ editSection ] = useEditSectionMutation();

    const tableId = table && table.id ? table.id : null;

    return (
        <Fragment>
            <img
                src={`${getFrontendURL()}/images/quote_icons/pencil.svg`}
                style={{ width: "24px", height: "24px" }}
                className={`section-editor section-base remove-on-export ${
                    (table && table.name && !modifySection) ||
                    (customSection && confirmedHeader && !modifySection)
                        ? ""
                        : "section-editor-hidden"
                }`}
                onClick={() => {
                    setModifySection(true);
                    setCurrentRowInEditing({ tableId: table.id });
                }}
            />
            <img
                src={`${getFrontendURL()}/images/quote_icons/trash.svg`}
                style={{ width: "22px", height: "22px" }}
                className={`section-editor section-base remove-on-export ${
                    (table && table.name && !modifySection) ||
                    (customSection && confirmedHeader && !modifySection)
                        ? ""
                        : "section-editor-hidden"
                }`}
                onClick={() => deleteCustomHeader(table.id, deleteSection)}
            />
            <img
                src={`${getFrontendURL()}/images/quote_icons/checkmark.svg`}
                style={{ width: "24px", height: "24px" }}
                className={`section-editor section-edit remove-on-export ${
                    (table && table.name && !modifySection) ||
                    (customSection && confirmedHeader && !modifySection)
                        ? "section-editor-hidden"
                        : ""
                }`}
                onClick={() => {
                    confirmCustomHeader(
                        customSection,
                        projectId,
                        setCustomSectionButtonPressed,
                        setConfirmedHeader,
                        setNewTable,
                        modifySection,
                        tableId,
                        setModifySection,
                        confirmSection,
                        editSection
                    );
                    setCurrentRowInEditing({});
                }}
            />
            <img
                src={`${getFrontendURL()}/images/quote_icons/times.svg`}
                style={{ width: "24px", height: "24px" }}
                className={`section-editor section-edit ${
                    (table && table.name && !modifySection) ||
                    (customSection && confirmedHeader && !modifySection)
                        ? "section-editor-hidden"
                        : ""
                }`}
                onClick={() => {
                    setCustomSectionButtonPressed(false);
                    setConfirmedHeader(false);
                    setModifySection(false);
                    setCurrentRowInEditing({});
                }}
            />
        </Fragment>
    );
};
